import { configureStore } from '@reduxjs/toolkit';

// Import reducers
import crecheReducer from '../state/creche';
import integrationsReducer from '../state/integrations';
import capitalReducer from '../state/capital';

// Configure Redux store with all pack reducers
const store = configureStore({
  reducer: {
    // Core pack reducers
    creche: crecheReducer,
    integrations: integrationsReducer,
    capital: capitalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore specific action types for better performance
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // Ignore specific paths in the state for non-serializable data
        ignoredPaths: ['capital.performance'],
      },
    }),
  devTools: import.meta.env?.DEV, // Enable Redux DevTools in development
});

export default store;